module.exports = __webpack_public_path__ + "static/media/2sample.3e427684.png";